<div class="container-fluid mt-4">
	<div class="d-flex justify-content-between align-items-center mb-4">
		<h1>Agendamentos</h1>
		<div class="d-flex gap-2">
			<button class="btn btn-success" (click)="abrirModalRomaneio()" [disabled]="isLoadingRomaneio">
				<i class="bi bi-printer"></i> Imprimir Romaneio
			</button>
			<button class="btn btn-primary" (click)="novoAgendamento()">Incluir Novo Agendamento</button>
		</div>
	</div>
	<hr />

	<!-- CALENDAR SECTION -->
	<div class="calendar-section mb-4">
		<div class="calendar-header">
			<button class="btn btn-sm btn-outline-secondary" (click)="previousMonth()">
				<i class="bi bi-chevron-left"></i>
			</button>
			<h3 class="calendar-title">{{ monthNames[currentMonth] }} {{ currentYear }}</h3>
			<button class="btn btn-sm btn-outline-secondary" (click)="nextMonth()">
				<i class="bi bi-chevron-right"></i>
			</button>
		</div>

		<div class="calendar-grid">
			<!-- Day names header -->
			<div class="calendar-day-name" *ngFor="let dayName of dayNames">{{ dayName }}</div>

			<!-- Calendar days -->
			<div
				*ngFor="let day of calendarDays"
				[class.calendar-day]="day !== null"
				[class.calendar-day-empty]="day === null"
				[class.today]="isToday(day)"
				[class.selected]="isSelectedDay(day)"
				[class.has-agendamentos]="getAgendamentosCountForDay(day) > 0"
				(click)="selectDay(day)"
			>
				<div class="day-number">{{ day }}</div>
				<div class="day-count" *ngIf="getAgendamentosCountForDay(day) > 0">
					{{ getAgendamentosCountForDay(day) }} agend.
				</div>
			</div>
		</div>

		<div class="calendar-footer" *ngIf="selectedDate">
			<span class="selected-date-info">
				Filtrado por: {{ selectedDate | date:'dd/MM/yyyy' }}
			</span>
			<button class="btn btn-sm btn-outline-secondary" (click)="clearDateFilter()">Limpar filtro</button>
		</div>
	</div>

	<!-- SEARCH SECTION -->
	<div class="mb-3">
		<div class="input-group">
			<input
				type="text"
				class="form-control"
				placeholder="Pesquisar por tipo, cliente, telefone, endereço ou descrição"
				[(ngModel)]="searchTerm"
			>
			<button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
			<button class="btn btn-outline-secondary" type="button" (click)="clearSearch()">Limpar</button>
		</div>
	</div>

	<div class="table-responsive">
		<table class="table table-striped table-hover">
			<thead class="thead-dark">
				<tr>
					<th scope="col">Tipo</th>
					<th scope="col">Data Agendamento</th>
					<th scope="col">Cliente</th>
					<th scope="col">Endereço</th>
					<th scope="col">Complexidade</th>
					<th scope="col">Conclusão</th>
					<th scope="col" class="text-center">Ações</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let agendamento of pagedAgendamentos">
					<td>{{ agendamento.tipoAgendamento }}</td>
					<td>{{ agendamento.dataAgendamento | date:'dd/MM/yyyy HH:mm' }}</td>
					<td>{{ agendamento.cliente.nomeRazaoSocial }}</td>
					<td class="text-truncate" style="max-width: 260px;" [title]="agendamento.enderecoAgendamento">
						{{ agendamento.enderecoAgendamento }}
					</td>
					<td>{{ agendamento.complexidade }}</td>
					<td>{{ agendamento.dataConclusao ? (agendamento.dataConclusao | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
					<td class="text-center">
						<button
							type="button"
							class="btn btn-warning btn-sm me-2"
							(click)="editarAgendamento(agendamento)"
						>
							Editar
						</button>
						<button
							type="button"
							class="btn btn-danger btn-sm"
							[disabled]="deletingId === agendamento.id"
							(click)="excluirAgendamento(agendamento)"
						>
							{{ deletingId === agendamento.id ? 'Excluindo...' : 'Excluir' }}
						</button>
					</td>
				</tr>

				<tr *ngIf="pagedAgendamentos.length === 0">
					<td colspan="8" class="text-center">Nenhum agendamento encontrado.</td>
				</tr>
			</tbody>
		</table>
	</div>

	<nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
		<ul class="pagination justify-content-center">
			<li class="page-item" [class.disabled]="currentPage === 0">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage === 0">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
			</li>
			<li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
			</li>
		</ul>
	</nav>
</div>

<!-- Modal de Data Range -->
<app-romaneio-date-range-modal 
  (dateRangeSelected)="gerarRomaneio($event)"
></app-romaneio-date-range-modal>

<!-- Componente PDF -->
<app-romaneio-pdf></app-romaneio-pdf>
